import { bl_fi_internal_sales_debit_note_import_file_hdr_RowClass } from '../../../dbschema/bl_fi_internal_sales_debit_note_import_file_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class SalesDebitNoteFileImportContainerModel extends BaseContainerModel {
    bl_fi_internal_sales_debit_note_import_file_hdr: bl_fi_internal_sales_debit_note_import_file_hdr_RowClass = new bl_fi_internal_sales_debit_note_import_file_hdr_RowClass();
}